<div class="md-page">

  <div class="md-tabs">
    <button class="md-tab" *ngFor="let t of tabs"
            [class.active]="activeTab === t.key"
            (click)="selectTab(t.key)">
      <span class="material-icons">{{ t.icon }}</span>
      <span class="md-tab-label">{{ t.label }}</span>
      <span class="md-tab-soon" *ngIf="!t.ready">Soon</span>
    </button>
  </div>

  <div class="md-body">
    <app-designations *ngIf="activeTab === 'designations'"></app-designations>

    <app-roles mode="roles" *ngIf="activeTab === 'roles'"></app-roles>

    <app-roles mode="users" *ngIf="activeTab === 'users'"></app-roles>

    <app-exceptions *ngIf="activeTab === 'exceptions'"></app-exceptions>

    <div class="md-placeholder" *ngIf="activeTab === 'forms'">
      <span class="material-icons">dynamic_form</span>
      <h3>Custom Forms</h3>
      <p>Build Zoho-style dynamic forms for onboarding, requests and approvals. Coming soon.</p>
    </div>

    <app-email-templates *ngIf="activeTab === 'automation'"></app-email-templates>
  </div>

</div>
